module.exports = __webpack_public_path__ + "static/media/b0_p3_crystal.0f7cbe1e.mp3";